<template>
  <img alt="Prof. Safadi" height="250" src="./assets/logo.png">
  <p>Welcome to Safadi Puzzler, the new interactive platform for learning and practicing programming and computer topics.
  <br>
  The platform is currently by invitation only. Please get in touch with <a href="https://hanisaf.github.io/scholarly-resume/">me</a> if you would like to join.
</p>
  <p>The following current courses are available:
    <br>
    <a href="https://advanced-data-management.safadi-puzzler.com/">Advanced data management and analytics</a>
    <br>
    <a href="https://data-engineering.safadi-puzzler.com/">Data engineering (Python)</a>
    <br>
  </p>
  
  <p>The following are old courses that are no longer maintained, but are still available for reference:
    <br>
    <a href="https://app.safadi-puzzler.com/">Data engineering (Java)</a>
    <br>
  </p>
  
</template>

<script>

export default {
  name: 'App',
  components: {},
  //data stores variables used in the template
  data: function() {
    return {
    }
  },
  //methods stores functions used in the template
  methods: {
    //run this function when the component is created

  },
  mounted() {
      document.title = "Safadi Puzzler";
    }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
